/**
 * Utility Function: Used to create a new custom optimised scroll event
 *
 * @param {string} [type='scroll'] - Event type trigger (default is 'scroll')
 * @param {string} [name='optimisedScroll'] - Name of new CustomEvent (default is 'optimisedScroll')
 * @param {Element} [obj=window] - Element object to bind event to (default is Window)
 */
export const optimisedScrollAnimation = ({ type = 'scroll', name = 'optimisedScroll', obj = window } = {}) => {
    let running = false,
        func = () => {
            if (running) return;

            running = true;
            requestAnimationFrame(() => {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };

    obj.addEventListener(type, func);
};
